import React, { useEffect, useRef } from "react";

/**
 * Shown after the user successfully records their last application of the day.
 * Styled similarly to the signed-out welcome overlay on the job list.
 */
function DailyLimitCelebrationModal({ onClose, dailyCap = 5 }) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onCloseRef.current();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        zIndex: 10100,
      }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="daily-limit-celebration-title"
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "2.75rem 2.5rem",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.12)",
          maxWidth: "560px",
          width: "100%",
          textAlign: "center",
          border: "1px solid #e9ecef",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            fontSize: "4rem",
            marginBottom: "1rem",
            lineHeight: 1,
          }}
          aria-hidden
        >
          🎉
        </div>
        <h1
          id="daily-limit-celebration-title"
          style={{
            color: "#2c3e50",
            fontSize: "1.85rem",
            fontWeight: "700",
            marginBottom: "0.75rem",
            lineHeight: "1.25",
          }}
        >
          You did it—all {dailyCap} applications are in!
        </h1>
        <p
          style={{
            color: "#7f8c8d",
            fontSize: "1.05rem",
            lineHeight: "1.55",
            marginBottom: "1.35rem",
          }}
        >
          That takes focus and follow-through. Be proud of showing up with
          intention today.
        </p>

        <div
          style={{
            textAlign: "left",
            padding: "1.25rem 1.35rem",
            backgroundColor: "#f4fff8",
            borderRadius: "12px",
            borderLeft: "4px solid #28a745",
            marginBottom: "1.75rem",
          }}
        >
          <p
            style={{
              color: "#155724",
              fontSize: "0.78rem",
              fontWeight: "700",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              margin: "0 0 0.65rem 0",
            }}
          >
            Reflection Time
          </p>
          <p
            style={{
              color: "#2c3e50",
              fontSize: "0.95rem",
              lineHeight: "1.55",
              margin: "0 0 0.75rem 0",
            }}
          >
            Step away from the screen for a bit. Your mind (and your
            applications) benefit from a real break—walk, eat, recharge.
          </p>
          <p
            style={{
              color: "#495057",
              fontSize: "0.9rem",
              lineHeight: "1.55",
              margin: 0,
            }}
          >
            Use this evening to sharpen a skill you saw in the job description,
            tidy your resume, or even research some of the companies you applied
            to. When you come back tomorrow, your slots reset—and you&apos;ll
            keep building the steady habit that wins job searches.
          </p>
        </div>

        <button
          type="button"
          onClick={onClose}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            padding: "1rem 2.25rem",
            borderRadius: "8px",
            fontSize: "1.05rem",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: "0 4px 12px rgba(0, 123, 255, 0.35)",
            width: "100%",
            maxWidth: "320px",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#0056b3";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#007bff";
            e.target.style.transform = "translateY(0)";
          }}
        >
          Back to browsing
        </button>
      </div>
    </div>
  );
}

export default DailyLimitCelebrationModal;
